import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  // Extracts pathname property(key) from an object

  // Automatically scrolls to top whenever pathname changes
  useEffect(() => {
    document.getElementById("auto-focus")?.scrollIntoView({
      behavior: "smooth",
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location.href]);

  return null;
};

export default ScrollToTop;
